//Configurator Utils
import {
    buildingGroup,
    mteMesh080,
    mteMesh100,
    mteMesh120,
    mteMesh140,
    mteMesh160,
    mteMesh180,
    mteMesh200
} from "../main";
import {findChildrenByName} from "./threeUtils";
import {getWallOrientation} from "../models/walls/wall";
import {
    floorGroupName,
    raehmMeshName,
    roofGroupName,
    supportBeamMeshName,
    wallGroupName,
    wallMeshBBoxName
} from "../constants/nameConstants";

export function isRoofOrFloor(object) {
    if (object === undefined) {
        return false;
    }

    if (object.name === roofGroupName || object.name === floorGroupName) {
        return true;
    }

    while (object.parent !== null && object.parent !== undefined && object.parent !== buildingGroup) {
        object = object.parent;
        if (object.name === roofGroupName || object.name === floorGroupName) {
            return true;
        }
    }

    return false;
}

export function isRoof(object) {
    if (object === undefined) {
        return false;
    }

    if (object.name === roofGroupName) {
        return true;
    }

    while (object.parent !== null && object.parent !== undefined && object.parent !== buildingGroup) {
        object = object.parent;
        if (object.name === roofGroupName) {
            return true;
        }
    }

    return false;
}

export function isFloor(object) {
    if (object === undefined) {
        return false;
    }

    if (object.name === floorGroupName) {
        return true;
    }

    while (object.parent !== null && object.parent !== undefined && object.parent !== buildingGroup) {
        object = object.parent;
        if (object.name === floorGroupName) {
            return true;
        }
    }

    return false;
}

export function isWallGroup(object) {
    if (object === undefined) {
        return false;
    }

    if (isRoofOrFloor(object)) {
        return false;
    }

    while (object.parent !== null && object.parent !== undefined && object.parent !== buildingGroup) {
        object = object.parent;
        if (object.name.toLowerCase().includes(wallGroupName.toLowerCase())) {
            return true;
        }
    }

    return false;

}

export function getWallGroupParent(object) {
    if (object === undefined) {
        return false;
    }

    if (!isWallGroup(object)) {
        return null;
    }

    while (object.parent !== null && object.parent !== undefined && object.parent !== buildingGroup) {
        object = object.parent;
        if (object.name.toLowerCase().includes(wallGroupName.toLowerCase())) {
            return object;
        }
    }

    return null;
}

export function getWallGroupsByOrientation(orientation, wallGroups = null) {
    wallGroups = wallGroups || findChildrenByName(buildingGroup, wallGroupName, false, true);
    let arr = [];
    for (let i = 0; i < wallGroups.length; i++) {
        if (getWallOrientation(wallGroups[i]) === orientation) {
            arr.push(wallGroups[i]);
        }
    }

    return arr;
}

export function getSupportBeamsByOrientation(orientation) {
    let supportBeams = findChildrenByName(buildingGroup, supportBeamMeshName, false, true);
    let arr = [];
    for (let i = 0; i < supportBeams.length; i++) {
        if (getWallOrientation(supportBeams[i]) === orientation) {
            arr.push(supportBeams[i]);
        }
    }

    return arr;
}

export function getRaehmeByOrientation(orientation, raehmMeshes = null) {
    if (raehmMeshes === null) {
        raehmMeshes = findChildrenByName(buildingGroup, raehmMeshName, false, true);
    }
    let arr = [];
    for (let i = 0; i < raehmMeshes.length; i++) {
        if (getWallOrientation(raehmMeshes[i]) === orientation) {
            arr.push(raehmMeshes[i]);
        }
    }

    return arr;
}

export function getWallElementsBoundingBoxMeshes() {
    let meshes = findChildrenByName(buildingGroup, wallMeshBBoxName, true, true);

    for (let i = meshes.length - 1; i >= 0; i--) {
        //Ignoriere Dach und Bodengruppen
        if (isRoofOrFloor(meshes[i])) {
            meshes.splice(i, 1);
        }
    }

    return meshes;
}

export function getOuterWalls() {
    let wallGroups = findChildrenByName(buildingGroup, wallGroupName, false, true);
    let outerWalls = [];
    for (let i = 0; i < wallGroups.length; i++) {
        let wallGroup = wallGroups[i];
        if (wallGroup.userData.isOuterWall === true) {
            outerWalls.push(wallGroup);
        }
    }

    return outerWalls;
}

export function getInnerWalls() {
    let wallGroups = findChildrenByName(buildingGroup, wallGroupName, false, true);
    let outerWalls = [];
    for (let i = 0; i < wallGroups.length; i++) {
        let wallGroup = wallGroups[i];
        if (wallGroup.userData.isOuterWall === false) {
            outerWalls.push(wallGroup);
        }
    }

    return outerWalls;
}

export function getWallGroups() {
    let wallGroups = findChildrenByName(buildingGroup, wallGroupName, false);
    let walls = [];
    for (let i = 0; i < wallGroups.length; i++) {
        if (!isRoofOrFloor(wallGroups[i])) {
            walls.push(wallGroups[i]);
        }
    }

    return walls;
}

export function getRoomLines() {
    return findChildrenByName(buildingGroup, "roomLineMesh", false, true);
}

export function getMTEMeshFromThickness(thickness) {
    if (thickness === 0.08) {
        return mteMesh080;
    } else if (thickness === 0.1) {
        return mteMesh100;
    } else if (thickness === 0.12) {
        return mteMesh120;
    } else if (thickness === 0.14) {
        return mteMesh140;
    } else if (thickness === 0.16) {
        return mteMesh160;
    } else if (thickness === 0.18) {
        return mteMesh180;
    } else if (thickness === 0.20) {
        return mteMesh200;
    }

    return mteMesh100;

    //throw new Error("No valid MTE Mesh found for provided thickness. Default thickness (100mm) was used.");
}
